// let urlProduct = '/products.json'
 const sendRequst = async (url)=>{
   const response = await fetch(url)
   let result = response.json()
   return result
 }

 export {sendRequst}